var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"flat":""},on:{"click":_vm.onClick}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("chevron_left")]),_vm._t("default",[_vm._v("Back")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }